















































































































































import { Component, Watch } from "vue-property-decorator";
import { EventWidgetComponent } from "../EventWidget";
import MagicValidator from "../../../magic/MagicValidator.vue";
import pltSourceManager from "../../../store";
import SelectComponent from "../../../components/DictSelectComponent/index.vue";
@Component({
  name: "DictSelectSingleWidget",
  components: {
    SelectComponent,
    MagicValidator
  }
})
export default class DictSelectSingleWidget
  extends EventWidgetComponent
  implements App.PuttedWidgetComponent, App.LinkedWidgetComponent, App.PutAbleWidgetComponent
{
  private show: boolean = false;
  private list: any[] = [];
  private checkList: any[] = [];
  private selectList: any[] | string = this.widget.multi ? [] : "";
  private radio: any = "";
  private groupList: any[] = [];
  putModel: any = {};
  params: App.LinkedWidgetComponentParam[] = [];
  private dictCode: string = "";

  handleClearInput() {
    if (Array.isArray(this.value)) {
      this.value = [];
    } else {
      this.value = "";
    }
    this.widget.text = "";
    this.putModel = {};
    this.handleEvent(this.value);
  }

  initText() {
    if (this.value) {
      const ext = Array.isArray(this.widget.ext) ? this.widget.ext : [this.widget.ext];
      
      if (this.isHtml) {
        if (this.widget.preset === "dialog") {
          this.widget.text = ext.map((i: any) => i.dictName).join("、");
        } else if (this.widget.preset === "select") {
          this.selectList = this.widget.multi ? ext.map((e: any) => e.dictCode) : ext[0].dictCode;
          this.widget.text = ext.map((i: any) => i.dictName).join("、");
          this.$forceUpdate();
        } else {
          if (this.widget.multi) {
            this.checkList = ext.map((e: any) => e.dictCode);
          } else {
            this.radio = ext[0].dictCode;
          }
        }
      } else if (this.widget.preset === "group") {
        this.checkList = ext.map((i) => i.dictCode);
      } else if (this.widget.preset === "select") {
        this.selectList = this.widget.multi ? ext.map((e: any) => e.dictCode) : ext[0].dictCode;
        this.widget.text = ext.map((i: any) => i.dictName).join("、");
        
        this.$forceUpdate();
      } else {
        this.widget.text = ext.map((i: any) => i.dictName).join("、");
      }
    }
  }

  get computedValue() {
    if (Array.isArray(this.value)) {
      return this.value;
    } else if (typeof this.value === "string") {
      return this.value.split(",").filter(Boolean);
    }
    return [];
  }

  reset() {
    this.widget.text = "";
    this.value = "";
    this.groupList = [];
    this.radio = "";

    this.putModel = { dictId: this.value, dictName: this.widget.text };
    this.handleEvent(this.value);
  }

  refresh(option: App.LinkEventOption) {
    this.params = [
      {
        key: option.property,
        value: option.value
      }
    ];

    this.reset();
  }

  setValue(value: string) {
    // this.reset();

    if (!/[0-9]+/.test(value)) {
      this.value = "";
      this.widget.text = "";
    } else {
      this.value = value.split(",")[0];
      this.widget.text = value.split(",")[1];
    }
    if (this.widget.preset === "group" || this.widget.preset === "select") {
      const v = value.split(",")[0].split(":").slice(-1);
      const item = this.groupList.find((i) => i.dictCode === v[0]);
      if (this.widget.preset === "group") {
        this.checkList = item ? [item.dictCode] : [];
      } else {
        this.selectList = item ? [item.dictCode] : this.widget.multi ? [] : "";
      }
      this.value = item ? item.typeCode + ":" + item.dictCode : "";

      this.putModel = item;
      this.handleEvent(this.value);
      return;
    }

    this.putModel = { dictId: this.value, dictName: this.widget.text };
    this.handleEvent(this.value);
  }
  @Watch("checkList", { deep: true })
  checkListHandler(n: any[]) {
    this.value = n.length ? this.groupList[0]?.typeCode + ":" + n.join() : "";
    if (!this.widget.multi) {
      if (n.length > 1) {
        this.checkList = n.slice(-1);
      }
      const item = this.groupList.find((i) => i.dictCode === n[0]);
      this.putModel = item;
      this.handleEvent(this.value);
    }
  }
  changeValue(val: any) {
    if (this.widget.multi) {
      let selected: any = [];
      this.groupList.forEach((e: any) => {
        val.forEach((d: any) => {
          if (d === e.dictCode) {
            selected.push(e);
          }
        });
      });
      this.value =
        this.groupList[0].typeCode + ":" + selected.map((e: any) => e.dictCode).join(",");
    } else {
      this.value = this.groupList[0].typeCode + ":" + val;
    }
    this.handleEvent(this.value);
  }
  confirm(data: any) {
    this.widget.ext = data.source;
    const item = data.source[0];
    this.putModel = item;
    this.handleEvent(this.value);
  }
  async getDistLists(params: any) {
    if (!localStorage.getItem("offline") || localStorage.getItem("offline") === "false") {
      try {
        const { data, success, message } = await pltSourceManager.getDataDict(params);
        if (!success) return this.$message.error("查询字典选项数据失败：" + message);
        this.groupList = data.records || data;
        // if (this.widget.multi) return;
        // this.radio = this.groupList[0].dictCode;
      } catch (error) {
        console.log(error);
      }
    }
  }

  async created() {
    // console.log("this.widget", this.widget);
    if (this.isHtml || this.widget.preset === "group" || this.widget.preset == "select") {
      if (this.widget.preset == "group" || this.widget.preset == "select") {
        const limiter = JSON.parse(this.widget.property.configValue);
        const current = await this.getCurrentSync();
        let params = {
          conditions: [{ key: "tendId", value: current.tenId }],
          fieldType: "dictionary",
          first: true,
          limiter: JSON.stringify(limiter),
          nest: true
        };
        await this.getDistLists(params);
      }
    }
    this.initText();
    const limiter = JSON.parse(this.widget.property.configValue);
    this.dictCode = limiter.value || "";
  }

  async showHandler() {
    if (!this.widget.readonly) {
      this.show = true;
    }
  }
}
